import React from 'react';
import * as _ from 'lodash';
import CompareBucketItem from './CompareBucketItem';
import {convertNumberToWord} from './../utils';

export default ({MAX_SIZE, currentModel, bucket, removeModelFromCompareBucket}) => {
    if(bucket.length  > 0) {
        const buttonReference = bucket.length === 1 ? currentModel.ratingsUrl : `/products/compare/?id=${_.map(bucket, 'id').join('-')}`;
        const buttonText = bucket.length === 1 ? 'Add more to compare' : 'View Compare';
        let text = '';

        if(bucket.length < MAX_SIZE) {
            text = (
                <p className="crux-body-copy crux-body-copy--small text-left">{`You can select ${convertNumberToWord(MAX_SIZE - bucket.length)} more`}</p>
            );
        } else {
            text = (
                <p className="crux-body-copy crux-body-copy--small text-left">Your compare is full. Remove an item to add more.</p>
            );
        }
        return (
            <div className="crux-body-copy compare-bucket-wrapper">
                { text }
                <div className="compare-bucket-items">
                    { bucket.map((product, index) => (
                        <CompareBucketItem
                            key={`${product.id}-model-row`}
                            product={product}
                            onRemove={removeModelFromCompareBucket}
                        />
                    )) }
                </div>
                <a
                    href={buttonReference}
                    className="crux-btn crux-btn-special--lg crux-btn-block compare-bucket__button--view"
                >
                    {buttonText}
                </a>
            </div>
        )
    } else {
        return (
            <div className="crux-body-copy empty-compare-bucket">
                <div className="background-image"></div>
                <p className="crux-body-copy crux-body-copy--small--bold">{`No ${currentModel.superCategoryName} to compare yet?`}</p>
                <p className="crux-body-copy crux-body-copy--small">{`Add up to ${convertNumberToWord(3)} ${currentModel.superCategoryName} to see a side-by-side comparison of our ratings and specs.`}</p>
                <a className="crux-btn crux-btn-primary--lg crux-btn-disabled crux-btn-block">Compare</a>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./resources/modules/products/v2_0/components/CompareBucketRedux/components/CompareBucketList.jsx